<template>
  <div class="container">
    <modal></modal>
    <beat-progress :loading="false"></beat-progress>
    <div class="login-form">
      <form action="/" method="post">
        <h2 class="text-center">Log in</h2>
        <div class="form-group">
          <input
            type="text"
            class="form-control"
            placeholder="Username"
            required="required"
            v-model="loginForm.username"
            autocomplete="off"
          />
        </div>
        <div class="form-group">
          <input
            type="password"
            class="form-control"
            placeholder="Password"
            required="required"
            v-model="loginForm.password"
            autocomplete="off"
          />
        </div>
        <div class="form-group">
          <button
            :disabled="$v.$invalid"
            v-on:click="submit"
            class="btn btn-primary btn-block"
          >
            Log in
          </button>
        </div>
        <div class="clearfix">
          <label class="pull-left checkbox-inline"
            ><input type="checkbox" /> Remember me</label
          >
          <a href="#" class="pull-right">Forgot Password?</a>
        </div>
      </form>
      <p class="text-center"><a href="#">Create an Account</a></p>
    </div>

    <div>{{ $v }}</div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import toastr from '../common/toastr-util';
import AuthenticationService from '../services/authentication-service';
import BeatProgress from '../components/controls/BeatProgress.vue';
import Modal from '../components/Modal.vue';

export default {
  name: 'login',
  components: { BeatProgress, Modal },
  data() {
    return {
      loginForm: {
        username: '',
        password: ''
      }
    };
  },
  validations: {
    loginForm: {
      username: {
        required
      },
      password: { required }
    }
  },
  methods: {
    submit(evt) {
      evt.preventDefault();
      AuthenticationService.login(
        this.loginForm.username,
        this.loginForm.password
      )
        .then(resp => {
          if (resp.data.error) {
            toastr.toast(
              'error',
              resp.data.error.message,
              'Authentication failure'
            );
          } else {
            this.$router.push({ path: '/' });
          }
        })
        .catch(error => {
          console.log(JSON.stringify(error));
        });
      return false;
    }
  }
};
</script>

<style>
.login-form {
  width: 380px;
  margin: 0 auto;
}
</style>
